import React from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { authActions } from "../../redux/auth";
import styled from "styled-components";
import dummyProfileImg from "./../../assets/img/dummy_profile_pic.png";
import ProfileHeader from "./ProfileHeader/ProfileHeader";
import ProfileGraph from "./ProfileGraph/ProfileGraph";
import ProfileTable from "./ProfileTable/ProfileTable";
import {
  GAP_BETWEEN_SECTIONS,
  SHOW_FAKE_PROFILE_PICTURE,
  SHOW_PROFILE_DESCRIPTION,
  SHOW_PROFILE_PICTURE,
  SHOW_SETTINGS_ICON,
  THEME_COLOR,
} from "config/profile_constants";

const Container = styled.main`
  font-family: Inria Sans;
  min-height: 100vh;
`;

const Wrapper = styled.section`
  width: calc(100vw - 2 * (126px));
  margin: 0 auto;
  min-width: 400px;
  margin-top: 78px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: ${GAP_BETWEEN_SECTIONS};
`;

const Profile = () => {
  const logoutHandler = () => {
    navigate("/");
    dispatch(authActions.checkProfile(false));
  };

  const addProfileImgToState = () => {
    if (SHOW_FAKE_PROFILE_PICTURE) {
      setProfileImg(dummyProfileImg);
    } else {
      // ADD API CALL HERE FOR PROFILE IMAGE
    }
  };

  const init = () => {
    addProfileImgToState();
  };

  React.useEffect(() => {
    init();
  }, []);

  const [profileImg, setProfileImg] = React.useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const themeColor = THEME_COLOR;

  return (
    <Container>
      <Wrapper>
        <ProfileHeader
          color={themeColor}
          logoutHandler={logoutHandler}
          showProfileDescription={SHOW_PROFILE_DESCRIPTION}
          showSettingsIcon={SHOW_SETTINGS_ICON}
          showProfilePicture={SHOW_PROFILE_PICTURE}
          profilePicture={profileImg}
        />
        <ProfileGraph />
        <ProfileTable />
      </Wrapper>
    </Container>
  );
};

export default Profile;
/** <button
        onClick={() => {
          
        }}
      >
        Logout
      </button>*/
